// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ChangeLanguage_buttonWrapper__UabGp","btn":"ChangeLanguage_btn__QvTov","active":"ChangeLanguage_active__Y8tq2"};